import { useSelector } from 'react-redux';
import { selectDealType } from '../../../selectors/page';
import { EDealType } from '../../../types/dealType';
import { EOfferStatusData } from '../../../types/offerHistory';
import { selectOfferFromHistory } from '../../../selectors/offersHistory';

export const useDeactivatedLabelTitle = (): string | null => {
  const offerFromHistory = useSelector(selectOfferFromHistory);
  const dealType = useSelector(selectDealType);

  if (offerFromHistory?.status === EOfferStatusData.Deactivated) {
    return dealType === EDealType.Sale ? 'Снято с продажи' : 'Снято с публикации';
  }

  return null;
};
